<template>
  <v-dialog
    :value="active"
    width="420"
    persistent
  >
    <v-card class="pa-6 text-center">
      <div class="text-body-1 mb-2">
        ¿Desea generar un nuevo expediente para <span class="font-weight-bold">{{ fullname }}</span>?
      </div>
      <v-card-actions>
        <v-row>
          <v-col cols="6">
            <ASecondaryButton
              label="Cancelar"
              @click="$emit('update:active', false)"
            />
          </v-col>
          <v-col cols="6">
            <APrimaryButton
              label="Sí, generar"
              :loading="isLoading"
              :disabled="isLoading"
              @click="triggerCreateExpedienteFromPreregistro()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import ASecondaryButton from '../atoms/ASecondaryButton.vue';
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';
import updatePersona from '../../modules/persona/application/updatePreregistro';

export default {
  components: {
    ASecondaryButton,
    APrimaryButton,
  },

  props: {
    active: {
      type: Boolean,
      required: true,
    },

    preregistro: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters('personal', {
      savedIdPersonal: 'getSavedIdPersonal',
    }),

    ...mapGetters('expediente', {
      expedienteId: 'getSavedExpedienteId',
      expedientePersonal: 'getExpedientesPersonal',
      expedientes: 'getExpedientes',
    }),

    fullname() {
      if (this.preregistro) {
        return `${this.preregistro.nombre} ${this.preregistro.segundo_nombre ?? ''} ${this.preregistro.apaterno} ${this.preregistro.amaterno}`;
      }

      return '';
    },
  },

  methods: {
    ...mapActions('personal', [
      'savePersonal',
      'updatePersonal',
      'saveCuip',
      'searchPersonal',
      'updatePersonalEdoFuerza',
    ]),
    ...mapActions('expediente', ['saveExpediente', 'fetchExpedientes', 'updateFolioExpediente']),

    async createExpedienteFromPreregistro() {
      const expediente = {
        folio: '',
        antiguedadInstitucion: this.preregistro.antiguedad_institucion ?? 0,
      };

      const personal = {
        nombre: this.preregistro.nombre,
        segundoNombre: this.preregistro.segundo_nombre ?? '',
        apaterno: this.preregistro.apaterno ?? '',
        amaterno: this.preregistro.amaterno ?? '',
        fechaNacimiento: moment(this.preregistro.fecha_nacimiento, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        nacionalidad: '',
        curp: this.preregistro.curp ?? '',
        nss: '',
        nsmi: '',
        pasaporte: '',
        rfc: this.preregistro.rfc ?? '',
        claveIne: '',
        licenciaConducir: '',
        vigenciaLicencia: 0,
        foto: '',
        fk_idTipoNacionalidad: 0,
        fk_idEstadoCivil: 0,
        fk_idEstatus: 6,
        fk_idMunicipioNacimiento: 0,
        fk_idMunicipioRadica: 0,
        fk_idPuestoDependencia: 0,
        fk_idRamaDependencia: 0,
        fk_idSubsede: 0,
        Contacto: {
          telefonoCelular: '',
          telefonoFijo: this.preregistro.telefono ?? '',
          correoElectronico: this.preregistro.email ?? 'correo@dominio.com',
          Direccion: {
            fk_idMunicipio: this.preregistro.direccion?.cat_municipio_id ?? 0,
            calle: this.preregistro.direccion?.calle ?? '',
            colonia: this.preregistro.direccion?.colonia ?? '',
            ext: this.preregistro.direccion?.ext ?? '',
            int: this.preregistro.direccion?.int ?? '',
            entrecalles: this.preregistro.direccion?.entrecalles_1 ?? '',
            entrecalles2: this.preregistro.direccion?.entrecalles_2 ?? '',
            referencias: '',
            lat: this.preregistro.direccion?.latitud ?? '',
            lgt: this.preregistro.direccion?.longitud ?? '',
            cp: this.preregistro.direccion?.cp ?? '',
          },
        },
        cartillaMilitar: '',
        fk_idCatGrupoSanguineo: 0,
        aptoSNPSP: true,
        capturo: '',
        fechaCaptura: '',
        ncp: '',
        smn: '',
        escolaridad: '',
        rangoCategoria: '',
        funciones: '',
        categorizacion: '',
        sueldoBase: '',
        jerarquiaPuesto: '',
        criticidadPuestoOperativo: '',
        categoriaPuestoCnca: '',
        funcional: '',
        unidadInvestigacion: '',
        unidadOperaciones: '',
        unidadAnalisisTactico: '',
        fechaIngresoEdoFza: '',
        estatusSnsp: '',
        estarLn: '',
        fechaBaja: '',
        motivoBaja: '',
        observaciones: '',
        examenC3Mes: '',
        vigenciaAnio: this.preregistro.id,
        observacionesC3: '',
        fk_idCatAmbito: 0,
        fk_idCatArea: null,
        fk_idCatSubArea: null,
      };

      await this.savePersonal({
        ...personal,
        fk_idCatArea: null,
        fk_idCatSubArea: null,
      });

      await this.saveExpediente({
        fk_idPersonal: this.savedIdPersonal,
        antiguedadInstitucion: expediente.antiguedadInstitucion,
      });

      const repository = createPersonaApiRepository();
      await updatePersona(repository, {
        ...this.preregistro,
        id_expediente_c3: this.expedienteId,
      });

      await this.fetchExpedientes();

      this.$emit('update:active', false);
    },

    async triggerCreateExpedienteFromPreregistro() {
      this.isLoading = true;
      try {
        await this.createExpedienteFromPreregistro();
      } catch (error) {
        this.$emit('update:active', false);
      }
      this.isLoading = false;
    },
  },
};
</script>
